(function (window, document, cookieConsentName, cookieName, cookieMaxAge, options) {
  window[cookieConsentName] = window[cookieConsentName] || {};

  const subscribers = [];
  const regExp = new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`);

  const get = () => {
    const value = document.cookie.replace(regExp, '$1');
    let consent;

    if (value) {
      try {
        consent = JSON.parse(decodeURIComponent(value));
      } catch (error) {}
    }

    return consent;
  };

  const set = (consent = {}) => {
    const consentDefaults = {
      version: '0.0.0',
      timestamp: Date.now(),
      necessary: true,
    };

    for (const p in consentDefaults) {
      if (consentDefaults.hasOwnProperty(p)) {
        consent[p] = consentDefaults[p];
      }
    }

    let value = '';

    try {
      value = encodeURIComponent(JSON.stringify(consent));
    } catch (error) {}

    if (value) {
      document.cookie = `${cookieName}=${value};expires=${new Date(new Date().getTime() + (cookieMaxAge || 365 * 864e5)).toUTCString()}`;

      for (const i in subscribers) {
        subscribers[i](consent);
      }
    }

    window[cookieConsentName].banner.hide();
  };

  const subscribe = (subscriber) => {
    let subscribed = true;

    subscribers.push(subscriber);

    return () => {
      if (subscribed) {
        subscribers.splice(subscribers.indexOf(subscriber), 1);
        subscribed = false;
      }
    };
  };

  window[cookieConsentName].consent = {
    get, set, subscribe, options,
  };
}(window, document, 'cookieConsent', 'cookie_consent', undefined, ['necessary', 'analytics', 'functional', 'targeting']));
